import { render, staticRenderFns } from "./PvDrawerArticleListTile.vue?vue&type=template&id=784301d2&scoped=true&"
import script from "./PvDrawerArticleListTile.vue?vue&type=script&lang=js&"
export * from "./PvDrawerArticleListTile.vue?vue&type=script&lang=js&"
import style0 from "./PvDrawerArticleListTile.vue?vue&type=style&index=0&id=784301d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784301d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent})
